import React, { useContext, useState, useEffect } from 'react';
import { RootContext } from '../../hoc/RootContext/RootContext';
import { useNavigate } from 'react-router-dom';
import { AdminSelect } from '@project/components';
import { useIntl } from 'react-intl';
import { FLOOR_LABELS } from '../../constants';

export default function ViewProfileFloors({ floorData }) {
  const intl = useIntl();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [floorData]);

  const {
    viewerProfile: profile
  } = useContext(RootContext);

  if (!floorData || !floorData.length || floorData.length === 1) return null;

  const mainGuid = profile.parent_guid || profile.guid;
  // prepare values for floor/level dropdown
  const currentFloor = profile.floor || 1;
  let options = floorData.map(_ => ({ ..._, label: FLOOR_LABELS[_.floor_label] || (_.floor_label && intl.formatMessage({id: 'floorLabels.level'}, {level: _.floor_label.split(' ')[1]})) || intl.formatMessage({id: 'floorLabels.level'}, {level: _.floor}) || _.floor_label || `Level ${_.floor}`, value: _.floor })).sort((a, b) => a.value - b.value);
  const currentFloorValue = { value: currentFloor, label: FLOOR_LABELS[profile.floor_label] || (profile.floor_label && intl.formatMessage({id: 'floorLabels.level'}, {level: profile.floor_label.split(' ')[1]})) || profile.floor_label || `Level ${currentFloor}`, guid: profile.guid };
  const onChangeLevel = ({ value }) => {
    if (currentFloor === value) return;
    setIsLoading(true);
    const levelParam = value === 1 ? '' : `?level=${value}`;
    navigate(`/profile/${mainGuid}${levelParam}`)
    window.location.reload()
  };

  return <AdminSelect options={options} value={currentFloorValue} onChange={onChangeLevel} label={intl.formatMessage({id: 'floorLabels.selector'})} isLoading={isLoading} />;
}
